import React, { ReactNode } from 'react';
import classNames from 'classnames';

export enum ButtonType {
	PRIMARY = 'primary',
	SECONDARY = 'secondary',
	TRANSPARENT ='transparent',
	STROKED = 'stroked',
	STROKED_PRIMARY = 'stroked-primary',
}

interface IProps {
	kind?: ButtonType,
	onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
	children: ReactNode,
	isDisabled?: boolean,
	type?: React.ButtonHTMLAttributes<HTMLButtonElement>['type'],
	nodeRef?: React.RefObject<any> | null;
	classes?: string;
	classPrefix?: string
	form?: string;
}

export const Button = ({
	kind = ButtonType.SECONDARY, type = "button", classes, isDisabled, children, onClick, nodeRef, form, classPrefix = ''
} : IProps) => {
	const baseClass = `${classPrefix}button`;

	const btnClass = classNames(baseClass, classes, {
		[`${baseClass}--${kind}`]: kind,
		'disabled': isDisabled
	});

	return (
		<button
			ref={nodeRef}
			className={btnClass}
			onClick={isDisabled ? undefined : onClick}
			type={type}
			form={form}
		>
			{children}
		</button>
	);
}